export default "__VITE_PUBLIC_ASSET__f2cbcfc2__"